<div [id]="identifierService.labelId('smartFollowup', 'permSched')" class="sectionTitle" style="margin-bottom: 5px" data-tx-key="label.gb.perm_sched">
  {{ labels['label.gb.perm_sched'] }}
</div>
<div [formGroup]="smartScheduleForm" class="smart-schedule-form">
  <div class="row">
    <div class="col-xs-1" style="padding-right: 0px">
      <div [id]="identifierService.labelId('smartFollowup', 'permStartingOn')" class="sectionTitle" style="text-align: top; margin-top: 10px" data-tx-key="label.gb.starting_on">
        {{ labels['label.gb.starting_on'] }}
      </div>
    </div>
    <div style="padding-left: 0px" [formGroup]="permScheduleForm">
      <mat-radio-group aria-label="Select an option" style="flex-direction: column; display: flex"
        formControlName="calculateFlg" id="permanentSchduleRadioGroup">
        <!--[disabled]="viewModeDisable()"-->
        <mat-radio-button value="true" style="margin-top: 10px" [checked]="isCheckedPermSchedule(true)"
          (change)="radioChange($event)" id="permDatePickerRadioButton">

        </mat-radio-button>
        <mat-radio-button value="false" style="margin-top: 32px" [checked]="isCheckedPermSchedule(false)"
          (change)="radioChange($event)" id="permDropDownRadioButton">
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-xs-4" [formGroup]="permScheduleForm">
      <div class="row mb-15">
        <div style="margin-left: 10px" class="col-xs-1"></div>
        <div class="col-xs-5" style="padding-right: 0px">
          <merlin-date-picker [isForm]="true" [placeHolder]="translatePlaceHolder()" [groupName]="permScheduleForm"
            controlName="startDate" id="dateInput" (changed)="onPermStartDateChange($event)">
          </merlin-date-picker>
        </div>
                <div class="col-xs-1" style="
                    padding-right: 0px;
                    visibility: hidden;
                ">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select>
              <mat-option>.</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div [id]="identifierService.labelId('smartFollowup', 'permThe')" style="margin-left: 10px" class="col-xs-1 align-text-center" data-tx-key="label.gb.the">
          {{labels['label.gb.the']}}
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select formControlName="transmitOnWeekCd" disableOptionCentering id="permOnWeekDropdown">
              @for (
                option of patientData
                .codes
                .transmitWeekCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option1_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select formControlName="transmitOnDayCd" disableOptionCentering id="permOnDayDropdown">
              @for (
                option of patientData
                .codes
                .transmitDayCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option2_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 8px">
        <div style="margin-left: 10px" class="col-xs-1"></div>
                <div [id]="identifierService.labelId('smartFollowup', 'permOf')" class="col-xs-4 align-text-center" style="
                    padding-right: 0px;
                    text-align: end;
                " data-tx-key="label.gb.of">
          {{labels['label.gb.of']}}
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select formControlName="transmitOnMonthCd" disableOptionCentering id="permOnMonthDropdown">
              @for (
                option of patientData
                .codes
                .transmitMonthCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option3_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="col-xs-1">
      <div style="display: flex; flex-direction: row; height: 100%">
                <div style="
                    flex: 1;
                    border-top: solid 1px black;
                    border-right: solid 1px black;
                    border-bottom: solid 1px black;
                ">
          <div></div>
        </div>
                <div style="
                    flex: 1;
                    width: 30px;
                    display: flex;
                    flex-direction: column;
                ">
          <div style="flex: 1; border-bottom: solid 1px black"></div>
          <div style="flex: 1"></div>
        </div>
      </div>
    </div>

    <div class="col-xs-5" style="position: relative" [formGroup]="permScheduleForm">
            <div style="
                display: flex;
                align-items: top;
                height: 100%;
            ">
        <div class="row" style="align-items: center;">
                    <div class="col-xs-3" style="
                        padding-left: 0px;
                        padding-right: 0px;
                    ">
            <div data-tx-key="label.gb.transmit_every">
              {{
              labels['label.gb.transmit_every'
             ]
              }}
            </div>
          </div>
                    <div class="col-xs-3" style="
                        padding-left: 10px;
                        padding-right: 10px;
                    ">
                        <mat-form-field appearance="outline" class="
                            merlin-textbox
                            compactInput
                            full-width
                        " floatLabel="always">
              <mat-select formControlName="frequencyCd" disableOptionCentering id="permFrequencyDropdown">
                @for (
                  option of patientData
                  .codes
                  .permSchdFrequencyCodes
                  ; track
                  option) {
                  <mat-option [id]="identifierService.listitemId('smartFollowup', 'permFreq_' + option.codeId)" [value]="option.codeId">
                    {{
                    labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                    }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
                    <div class="col-xs-1" style="
                        padding-left: 10px;
                        padding-right: 10px;
                    ">
            <div [id]="identifierService.labelId('smartFollowup', 'for')" data-tx-key="label.gb.for">{{labels['label.gb.for']}}</div>
          </div>
                    <div class="col-xs-3" style="
                        padding-left: 10px;
                        padding-right: 10px;
                    ">
                        <mat-form-field appearance="outline" class="
                            merlin-textbox
                            compactInput
                            full-width
                        " floatLabel="always">
              <mat-select formControlName="durationCd" disableOptionCentering id="permDurationDropdown">
                @for (
                  option of patientData
                  .codes
                  .permSchdDurationCodes
                  ; track
                  option) {
                  <mat-option [id]="identifierService.listitemId('smartFollowup', 'permDuration_' + option.codeId)" [value]="option.codeId">
                    {{
                    labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-xs-1" style="margin-top: 1rem">
            <span>
                            <mat-icon [mdePopoverTriggerFor]="
                                dataRatesPopover
                            " style="margin-top: -10px">
                <img src="assets/images/question.png" style="margin-left: 5px" />
              </mat-icon>
            </span>
            <mde-popover #dataRatesPopover="mdePopover" [mdePopoverOverlapTrigger]="false"
              mdePopoverPositionX="after" mdePopoverPositionY="above" mdePopoverArrowOffsetX="15">
              <mat-card appearance="outlined" style="max-width: 500px">
                <mat-card-content>
                  <p [id]="identifierService.labelId('smartFollowup', 'tooltipText')" [innerHTML]="getTooltipText()">
                    <!-- {{
                    'msg.gb.sched_forlife_rollover']
                    }} -->
                  </p>
                </mat-card-content>
              </mat-card>
            </mde-popover>
          </div>
          @if (shouldView()) {
            <p [id]="identifierService.labelId('smartFollowup', 'bringPatInClinic')" class="fontnone" data-tx-key="label.gb.bring_pat_in_clinic">
              {{
              labels['label.gb.bring_pat_in_clinic'
             ]
              }}
            </p>
          }
        </div>
      </div>
    </div>
  </div>

  <div style="margin-top: 15px"></div>

  <div class="sectionTitle" style="margin-bottom: 5px">
    <mat-checkbox formControlName="tempEnabledFlg" (change)="onToggleTempSelection($event)" id="tempEnabledCheckbox"
      data-tx-key="label.gb.switch_to_temp_sched">
      {{
      labels['label.gb.switch_to_temp_sched']
      }}
    </mat-checkbox>
  </div>
  <div class="row" [formGroup]="tempScheduleForm">
    <div class="col-xs-1" style="padding-right: 0px">
      <div [id]="identifierService.labelId('smartFollowup', 'tempStartingOn')" class="sectionTitle" style="text-align: top; margin-top: 10px" data-tx-key="label.gb.starting_on">
        {{ labels['label.gb.starting_on'] }}
      </div>
    </div>
    <div style="padding-left: 0px">
      <mat-radio-group aria-label="Select an option" style="flex-direction: column; display: flex"
        formControlName="calculateFlg" id="tempScheduleRadioGroup">
        <mat-radio-button value="true" style="margin-top: 10px" [checked]="isTempScheduleChecked(true)"
          (change)="tempRadioChange($event)" id="tempDatePickerRadioButton">

        </mat-radio-button>
        <mat-radio-button value="false" [checked]="isTempScheduleChecked(false)" style="margin-top: 32px"
          id="tempDropDownRadioButton2" (change)="tempRadioChange($event)">

        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-xs-4">
      <div class="row mb-15">
        <div style="margin-left: 10px" class="col-xs-1"></div>
        <div class="col-xs-5" style="padding-right: 0px">
          <merlin-date-picker [isForm]="true" [placeHolder]="translatePlaceHolder()" [groupName]="tempScheduleForm"
            controlName="startDate" id="tempStartDatepicker" (changed)="onTempStartDateChange($event)">
          </merlin-date-picker>
        </div>
                <div class="col-xs-1" style="
                    padding-right: 0px;
                    visibility: hidden;
                ">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select>
              <mat-option>.</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div [id]="identifierService.labelId('smartFollowup', 'tempThe')" style="margin-left: 10px" class="col-xs-1 align-text-center" data-tx-key="label.gb.the">
          {{labels['label.gb.the']}}
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        compactInput
                        full-width
                    " floatLabel="always">
                        <mat-select formControlName="transmitOnWeekCd" disableOptionCentering id="tempOnWeekDropdown"><!--[disabled]="
                            tempDropDownActive()
                         "-->
              @for (
                option of patientData
                .codes
                .transmitWeekCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option4_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        compactInput
                        full-width
                    " floatLabel="always">
            <mat-select formControlName="transmitOnDayCd" disableOptionCentering id="tempOnDayDropdown">
              @for (
                option of patientData
                .codes
                .transmitDayCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option5_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                  }}
                </mat-option>
              }
            </mat-select>
                        <!--[disabled]="
                            tempDropDownActive()
                        "-->
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 8px">
        <div style="margin-left: 10px" class="col-xs-1"></div>
                <div [id]="identifierService.labelId('smartFollowup', 'tempOf')" class="col-xs-4 align-text-center" style="
                    padding-right: 0px;
                    text-align: end;
                " data-tx-key="label.gb.of">
          {{labels['label.gb.of']}}
        </div>
        <div class="col-xs-4" style="padding-right: 0px">
                    <mat-form-field appearance="outline" class="
                        merlin-textbox
                        full-width
                        compactInput
                    " floatLabel="always">
            <mat-select disableOptionCentering formControlName="transmitOnMonthCd" id="tempOnMonthDropdown">
              @for (
                option of patientData
                .codes
                .transmitMonthCodes
                ; track
                option) {
                <mat-option [id]="identifierService.listitemId('smartFollowup', 'mat-option6_' + option.codeId)" [value]="option.codeId">{{
                  labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                }}</mat-option>
              }
            </mat-select>
                        <!--[disabled]="
                            tempDropDownActive()
                         "-->
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="col-xs-1">
      <div style="display: flex; flex-direction: row; height: 100%">
                <div style="
                    flex: 1;
                    border-top: solid 1px black;
                    border-right: solid 1px black;
                    border-bottom: solid 1px black;
                ">
          <div></div>
        </div>
                <div style="
                    flex: 1;
                    width: 30px;
                    display: flex;
                    flex-direction: column;
                ">
          <div style="flex: 1; border-bottom: solid 1px black"></div>
          <div style="flex: 1"></div>
        </div>
      </div>
    </div>
    <div class="col-xs-5" style="position: relative">
            <div style="
                display: flex;
                align-items: top;
                height: 100%;
            ">
        <div class="row" style="align-items: center">
                    <div class="col-xs-3" style="
                        padding-left: 0px;
                        padding-right: 0px;
                    ">
            <div [id]="identifierService.labelId('smartFollowup', 'tempTransmitEvery')" data-tx-key="label.gb.transmit_every">
              {{
              labels['label.gb.transmit_every'
             ]
              }}
            </div>
          </div>
                    <div class="col-xs-3" style="
                        padding-left: 10px; 
                        padding-right: 10px;
                    ">
                        <mat-form-field appearance="outline" class="
                            merlin-textbox
                            compactInput
                            full-width
                        " floatLabel="always" [class]="matcher ? 'mat-form-field-invalid':''">
              <mat-select formControlName="frequencyCd" disableOptionCentering id="tempFrequencyDropdown"
                (click)="setOnCallDropdownError(false)">
                @for (
                  option of patientData
                  .codes
                  .tempSchdFrequencyCodes
                  ; track
                  option) {
                  <mat-option [id]="identifierService.listitemId('smartFollowup', 'tempFreq_' + option.codeId)" [value]="option.codeId">
                    {{
                    labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code]
                    }}
                  </mat-option>
                }
              </mat-select>
              <!-- [disabled]="tempFreqDurActive()" -->
            </mat-form-field>
          </div>
                    <div class="col-xs-1" style="
                        padding-left: 10px;
                        padding-right: 10px;
                    ">
            <div [id]="identifierService.labelId('smartFollowup', 'for')" data-tx-key="label.gb.for">{{ labels['label.gb.for'] }}</div>
          </div>
                    <div class="col-xs-3" style="
                        padding-left: 10px;
                        padding-right: 10px;
                    ">
                        <mat-form-field appearance="outline" class="
                            merlin-textbox
                            compactInput
                            full-width
                        " floatLabel="always" [class]="matcher ? 'mat-form-field-invalid':''">
              <mat-select formControlName="durationCd" disableOptionCentering id="tempDurationDropdown"
                (click)="setOnCallDropdownError(false)"><!-- [disabled]="tempFreqDurActive()"-->
                @for (
                  option of patientData
                  .codes
                  .tempSchdDurationCodes
                  ; track
                  option) {
                  <mat-option [id]="identifierService.listitemId('smartFollowup', 'tempDuration_' + option.codeId)" [value]="option.codeId">
                    {{ labels['data.Code.'+option.qualifier+'.Code_Desc.'+ option.code] }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <p [id]="identifierService.labelId('smartFollowup', 'revertToPermSched')" data-tx-key="label.gb.revert_to_perm_sched">
            {{ labels['label.gb.revert_to_perm_sched'] }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
